import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { AppComponent } from 'src/app/app.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { NavigatorService } from 'src/app/core/navigator/navigator.service';

declare const VERSION: string;

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'www.siscontrol.ch',
  },
  palette: {
    popup: {
      background: '#6b6b6b',
    },
    button: {
      background: '#0fafa9',
    },
  },
  theme: 'edgeless',
  position: 'bottom',
  type: 'info',
  showLink: false,
  content: {},
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/translations/',
        suffix: `.json?version=${VERSION}`,
        useHttpBackend: true,
      }),
    }),
    CoreModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    NavigatorService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
